import Button from '@mui/material/Button';
import { Grid, Box, Typography } from "@mui/material";
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import styled from 'styled-components';
import { useContext, useEffect } from 'react';
import { GameContext } from '../../../contexts/GameContext';
import { InstructionList } from '../../Welcome/Styled'
import { GameState } from '../../../interface/GameState';
import { AppContext } from '../../../contexts/AppContext';
import { setStyle } from '../../../util';


const Instructions = () => {
    const { setGameState, interfaceParams } = useContext(GameContext);
    const { defaultValues } = useContext(AppContext);

    useEffect(() => {
        if (defaultValues) setStyle(defaultValues);
    })

    return (
        <>
        <Container className="bg2" style={{ backgroundColor: "transparent !important"}}>
            <Grid className="wrapper-instruction" container direction="row" sx={{minHeight: '100dvh'}}>
                <Grid className="wrapper-demie-logo wrapper-demie-video"xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Card>
                        <CardMedia
                            component="video"
                            src="/video/Tutoriel_jeu_serieux_v1.mp4" // Replace with your video source
                            controls // Adds video controls
                            title="Descriptive title for the video"
                        />
                    </Card>
                </Grid>
                <Grid className="wrapper-demie-contenu" xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Box className="container-contenu" sx={{paddingRight: '0'}}>
                        {interfaceParams ? (
                <Container style={{color: '#000' }}>
                    <Title>Fonctionnement du jeu</Title>
                    {/* <Typography>Le but du jeu est d'obtenir le plus haut score en effectuant les décisions optimales.</Typography> */}
                    {/*<Text>{interfaceParams.instructions.description}</Text>*/}
                    {/* <InstructionList>
                        {interfaceParams.instructions.rules.map((r, idx) =>
                            <li key={"li-" + idx.toString()}>{r}</li>
                        )}
                    </InstructionList> */}
                    <Text>Cette courte vidéo explicative vous permettra de comprendre le fonctionnement du jeu.</Text>

                    <Typography>But du jeu</Typography>
                    <Text>Le but du jeu est d’optimiser les conditions intérieures d’un logement de sorte à minimiser la consommation d’énergie et favoriser le confort des personnes qui y vivent. L’objectif est donc de maximiser son pointage avant la fin de la partie.</Text>
                    <Typography>Pointage</Typography>
                    <Text>Le pointage est un indicateur de performance cumulatif qui est actualisé à chaque tour de jeu. Cet indicateur fait un bilan de la performance énergétique du logement, de la qualité de l’air et du confort thermique du ménage au cours du tour de jeu. À la fin de la partie, la personne participante peut voir son pointage moyen pour toutes les rondes jouées.</Text>
                    <Typography fontSize={20}>Déroulement</Typography>
                    <Text>La partie se divise en trois rondes de jeu, c’est-à-dire une simulation de trois journées. Des décisions pour optimiser les conditions intérieures et le confort peuvent être prises chaque heure de la journée entre 7 :00 à 23 :00. La personne participante est libre d’avancer le temps par bond d’une heure lorsque ses décisions à appliquer pour l’heure qui suit sont prises. À la fin de la journée, un bilan des performances est produit avant de passer à la ronde suivante.</Text>

                    <Button
                        className="serious-btn"
                        sx={{ "width": "fit-content", "alignSelf": "center" }}
                        onClick={() => { setGameState(GameState.ROUND) }}
                        variant="contained">
                        Démarrer le jeu
                    </Button>
                </Container>
            ) : null}
                    </Box>
                </Grid>
            </Grid>
        </Container>
        {/*
        <div className='bg2' style={{ padding: "2em", borderRadius: "5px"}}>
            {interfaceParams ? (
                <Container>
                    <Title>{interfaceParams.instructions.title}</Title>
                    <Text>{interfaceParams.instructions.description}</Text>
                    <InstructionList>
                        {interfaceParams.instructions.rules.map((r, idx) =>
                            <li key={"li-" + idx.toString()}>{r}</li>
                        )}
                    </InstructionList>

                    <Button
                        sx={{ "width": "fit-content", "alignSelf": "center" }}
                        onClick={() => { setGameState(GameState.ROUND) }}
                        variant="contained">
                        Démarrer le jeu
                    </Button>
                </Container>
            ) : null}

        </div>
        */}
        </>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
`

export const Title = styled.h3`
    margin-bottom: .1em;
`

export const Text = styled.p`
    margin-bottom: .1em;
    font-size: 17px !important;
`


export default Instructions;
